<template>
    <CustomTopSheetDialog v-model="dialogVisible" :width="900" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ !formData?.id ? $t('global.menu.backoffice.createCountry') : $t('global.menu.backoffice.editCountry',
                    { country: formData.nameTranslations[`name${selectedLanguage.toUpperCase()}`]}) }}
            </h3>
        </template>

        <template #default>

            <v-row class="shop-info-container">
                <!-- Linke Spalte: Basisinformationen -->
                <v-col cols="6">

                    <v-row justify="center" align="center">
                        <v-col>
                            <v-label class="mr-4">{{ $t('global.form.name') }}</v-label>
                            <v-text-field variant="outlined" v-model="formData.nameTranslations.nameDE"
                                density="compact" :hide-details="true"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                        <v-col>
                            <v-label class="mr-4">{{ $t('global.form.name-en') }}</v-label>
                            <v-text-field variant="outlined" v-model="formData.nameTranslations.nameEN"
                                density="compact" :hide-details="true"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                        <v-col>
                            <v-label class="mr-4">{{ $t('global.form.code') }}</v-label>
                            <v-text-field variant="outlined" v-model="formData.code" density="compact"
                                :hide-details="true"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                        <v-col>
                            <v-checkbox density="compact" v-model="formData.vouchersAvailable" hide-details="true">
                                <template v-slot:label>
                                    <v-label class="mr-4">{{ $t('global.form.vouchersAvailable') }}</v-label>
                                </template>
                            </v-checkbox>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="6">
                    <v-row justify="center" align="center" v-if="formData.id">
                        <v-col>
                            <v-label class="mr-4">{{ $t('global.form.defaultArea') }}</v-label>
                            <v-select variant="outlined" v-model="formData.defaultAreaId" density="compact"
                                item-value="id" :item-title="`properties.name${selectedLanguage.toUpperCase()}`"
                                :items="formData.areas" :hide-details="true"></v-select>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                        <v-col>
                            <v-label class="mr-4">{{ $t('global.form.defaultLanguage') }}</v-label>
                            <v-text-field variant="outlined" v-model="formData.defaultLanguage" density="compact"
                                :hide-details="true"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                        <v-col>
                            <v-label class="mr-4">{{ $t('global.form.sortOrder') }}</v-label>
                            <v-text-field variant="outlined" v-model="formData.sortIndex" density="compact"
                                :hide-details="true"></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>

                <!-- {{ formData }} -->
            </v-row>

        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="save">{{ $t('global.form.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
export default {
    name: "CreateCountryDialog",
    components: {
    },


    methods: {
    },
};
</script>
<script setup>
import { ref, inject, onMounted, computed, watch, getCurrentInstance, defineProps, defineEmits, defineModel } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';


const dialogVisible = defineModel(); // Handles v-model for visibility
const formData = defineModel("data", { default: () => ({ nameTranslations: {} }) }); // Handles v-model for the object
const selectedLanguage = localStorage.getItem('selectedLanguage');
defineProps({
    save: Function, // Define prop as a function
});



watch(formData, (newValue) => {
    console.log('watch(formData',newValue);
    if (!newValue) {
        formData.value = { nameTranslations: {} };
    }
});
watch(dialogVisible, (newValue) => {
    if (!newValue) {
        formData.value = { nameTranslations: {} };
    }
});

// const vouchersAvailableBoolean = computed({
//     get: () => formData.value.vouchersAvailable === "true", // Safely check
//     set: (val) => {
//         if (formData.value) { // Ensure properties exist before setting value
//             formData.value.vouchersAvailable = val ? "true" : "false";
//         }
//     },
// });

const closeSheet = () => {
    dialogVisible.value = false;
    formData.value = { nameTranslations: {} };
}
onMounted(() => {

});
</script>

<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}

.v-col>.v-label,
.v-col>.v-checkbox .v-label {
    font-weight: 700;
    font-size: 14px;
    opacity: 1;
}

.shop-description-input textarea,
.shop-info-container .v-field__input {
    font-size: 14px !important;
    font-weight: 300 !important;
}

.emoji-picker-container {
    width: 300px;
    /* Adjust width as needed */
    height: 400px;
    /* Adjust height as needed */
    overflow-y: auto;
    /* Add scroll if content overflows */
    padding: 8px;
}

.date-picker .v-field .v-field__append-inner {
    background-color: rgb(var(--v-theme-default)) !important;
}

.time-input .v-field__input {
    padding-right: 0px;
}

.create-news-tabs .v-tab {
    font-weight: 600 !important;
}
</style>

<style scoped>
.v-tab-selected {
    border: 1px solid #ddd !important;
    border-bottom: 0 !important;
}

.v-window-item--active {
    border-top: 0 !important;
    border: 1px solid #ddd !important;
}
</style>
